"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var react_router_dom_1 = require("react-router-dom");
function useScrollToTop(ref) {
    var location = react_router_dom_1.useLocation();
    var el = ref && ref.current;
    react_1.useEffect(function () {
        if (el)
            el.scrollTop = 0;
        else if (el === undefined)
            window.scrollTo(0, 0);
    }, [el, location.pathname]);
}
exports.useScrollToTop = useScrollToTop;
